import styled from "styled-components";

import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Table } from "library";
import {
  BackButton,
  CustomModal,
  Spinner,
  HeaderContainer,
  Heading2,
} from "components";

import { useListaInscritosEidu } from "./useListaInscritosEidu";

function siNoLabel(value: boolean | null | undefined) {
  if (value === true) return "Sí";
  if (value === false) return "No";
  return "";
}

export function ListaInscritosEidu() {
  const {
    data,
    filteredDataDocente,
    isLoading,
    isFetching,
    isDeleteModalVisible,
    handleCancelDelete,
    handleOnEdit,
    handleDelete,
    handleGoBack,
    handleOkDelete,
    handleExport,
  } = useListaInscritosEidu();

  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Identificación",
      dataIndex: "identificacion",
      key: "identificacion",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "País",
      dataIndex: "pais",
      key: "pais",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Correo de contacto",
      dataIndex: "correoInstitucional",
      key: "correoInstitucional",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Teléfono",
      dataIndex: "telefono",
      key: "telefono",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Perteneciente a",
      dataIndex: "universidad",
      key: "universidad",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Unidad Académica",
      dataIndex: "unidad",
      key: "unidad",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Programa / Carrera",
      dataIndex: "carrera",
      key: "carrera",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Taller",
      dataIndex: "taller",
      key: "taller",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Tiene discapacidad",
      dataIndex: "tieneDiscapacidad",
      key: "tieneDiscapacidad",
      render: (value: boolean) => <p>{siNoLabel(value)}</p>,
    },
    {
      title: "Tipo de discapacidad",
      dataIndex: "tipoDiscapacidad",
      key: "tipoDiscapacidad",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Requiere apoyo",
      dataIndex: "requiereApoyo",
      key: "requiereApoyo",
      render: (value: boolean) => <p>{siNoLabel(value)}</p>,
    },
    {
      title: "Detalle de apoyo",
      dataIndex: "detalleApoyo",
      key: "detalleApoyo",
      render: (text: string) => <p>{text}</p>,
    },
    {
      title: "Opciones",
      dataIndex: "id",
      key: "id",
      fixed: "right" as const,
      render: (record: any) => (
        <ActionsList>
          <StyledIconButton
            onClick={() => handleOnEdit(record)}
            variant="link"
            icon={<EditOutlined />}
          />
          <StyledIconButton
            onClick={() => handleDelete(record)}
            variant="link"
            icon={<DeleteOutlined />}
          />
        </ActionsList>
      ),
    },
  ];

  return (
    <>
      <HeaderContainer>
        <BackButton
          text="Periodo de Matrícula"
          onClick={() => handleGoBack()}
          link="/admin"
        />
      </HeaderContainer>

      {data && (
        <>
          <PageHeader>
            <Heading2>{data.nombre}</Heading2>
            <StyledButton variant="secondary" onClick={handleExport}>
              Exportar lista
            </StyledButton>
          </PageHeader>
          <DesktopTable>
            <StyledTable
              columns={columns}
              dataSource={filteredDataDocente}
              rowKey="id"
              loading={{
                spinning: isLoading || isFetching,
                indicator: <Spinner isLoading={isLoading || isFetching} />,
              }}
              scroll={{ x: 2600 }}
            />
          </DesktopTable>
          <CustomModal
            okText="Eliminar"
            cancelText="Cancelar"
            title="Eliminar Docente"
            text="¿Está seguro que desea eliminar el docente seleccionado?"
            visible={isDeleteModalVisible}
            onOk={handleOkDelete}
            onCancel={handleCancelDelete}
            variant="danger"
          ></CustomModal>
        </>
      )}
    </>
  );
}

const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

const StyledButton = styled(Button)`
  width: auto;
  min-width: 180px;
  margin: 0;
  float: none;
`;

const DesktopTable = styled.div`
  @media (min-width: 1200px) {
    display: block;
  }
`;

const ActionsList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledIconButton = styled(Button)`
  width: auto;
  min-width: auto;
  box-shadow: none;
  background: transparent;
  padding: 0 12px;
`;

const StyledTable = styled(Table)`
  td.ant-table-cell * {
    font-size: 18px;
    line-height: 25.2px;
    color: ${(props) => props.theme.colors.blackOne};
  }
`;
